import { matchPath } from 'react-router-dom';
import { makeLineItemClaimLoader, redirect } from '~/utils/routing';

const { loader, useLoaderData } = makeLineItemClaimLoader(
  ({ context, request }) => {
    // The layout has a loader, but not index route so this keeps the app from just rendering the layout if the step is missing
    const pathMatch = matchPath(
      '/:store/order/:idFromPlatform/:claimType/:draftId/:step/*',
      new URL(request.url).pathname,
    );

    return pathMatch ? context.claim : redirect('quantity');
  },
);

export { loader, useLoaderData };
